export default "__VITE_ASSET__DDNnGJK8__"